<script>
import {mapState} from "vuex"

export default {
    name: "FeesImportedData",

    data() {
        return {
            form: {
                year: null,
                accounting_firm_company_id: null,
            },
            tableData: [],
            loading: false,
        }
    },

    computed: {
        ...mapState({
            accountingFirmCompanies: (state) =>
                state.data.options.accountingFirmCompanies,
        }),

        yearOptions() {
            const currentYear = new Date().getFullYear();
            const options = [];

            for (let i = 0; i < 5; i++) {
                const year = currentYear - i;
                options.push({text: year.toString(), value: year});
            }

            return options;
        },

        disableLoad() {
            return this.form.accounting_firm_company_id === null || this.form.year === null
        },

        fields() {
            return [
                {key: 'month', label: 'Mois', thClass: 'text-left'},
                {key: 'imported_at', label: 'Importé le', thClass: 'text-left'},
                {key: 'nb_lines', label: 'Nb lignes importées', thClass: 'text-right'},
                {key: 'amount_total', label: 'Montant total', thClass: 'text-right'},
                {key: 'nb_lines_used', label: 'Nb lignes utilisées', thClass: 'text-right'},
                {key: 'amount_used', label: 'Montant utilisé', thClass: 'text-right'},
            ]
        }
    },

    methods: {
        async loadData() {
            if (this.disableLoad) {
                return;
            }

            this.loading = true;
            try {
                const response = await axios.get('feesImportations/imported-data', {
                    params: {
                        year: this.form.year,
                        accounting_firm_company_id: this.form.accounting_firm_company_id,
                    }
                });
                this.tableData = response.data.data;
            } catch (e) {
                console.error('Error loading imported data:', e);
                this.tableData = [];
            } finally {
                this.loading = false;
            }
        },

        formatNumber(value) {
            return Number(value).toLocaleString('fr-FR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },

        formatDateTime(value) {
            if (!value) return ''
            const d = new Date(value)
            if (Number.isNaN(d.getTime())) return ''
            return d.toLocaleString('fr-FR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
            })
        },

        getMonthName(monthNumber, year) {
            const months = [
                'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
                'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
            ];
            const monthName = months[monthNumber - 1] || '';
            return year ? `${monthName} ${year}` : monthName;
        }
    },

    watch: {
        'form.year'() {
            if (this.form.year && this.form.accounting_firm_company_id) {
                this.loadData();
            }
        },
        'form.accounting_firm_company_id'() {
            if (this.form.year && this.form.accounting_firm_company_id) {
                this.loadData();
            }
        }
    }
}
</script>

<template>
    <div>
        <b-row>
            <b-col sm="6">
                <label>Cabinet</label>
                <b-select v-model="form.accounting_firm_company_id" :options="accountingFirmCompanies">
                    <template #first>
                        <b-form-select-option :value="null" disabled>
                            --- Choisir le cabinet ---
                        </b-form-select-option>
                    </template>
                </b-select>
            </b-col>
            <b-col sm="6">
                <label>Année</label>
                <b-select v-model="form.year" :options="yearOptions">
                    <template #first>
                        <b-form-select-option :value="null" disabled>
                            --- Choisir l'année ---
                        </b-form-select-option>
                    </template>
                </b-select>
            </b-col>
        </b-row>

        <div v-if="loading" class="text-center mt-3">
            <b-spinner label="Chargement..."></b-spinner>
        </div>

        <b-table
            v-else-if="tableData.length > 0"
            responsive
            small
            :items="tableData"
            :fields="fields"
            class="mt-3"
        >
            <template #cell(month)="data">
                {{ getMonthName(data.item.month, form.year) }}
            </template>
            <template #cell(imported_at)="data">
                <span class="d-block">{{ formatDateTime(data.item.imported_at) }}</span>
            </template>
            <template #cell(nb_lines)="data">
                <span class="text-right d-block">{{ data.item.nb_lines }}</span>
            </template>
            <template #cell(amount_total)="data">
                <span class="text-right d-block number-font">{{ formatNumber((data.item.total_credit || 0) - (data.item.total_debit || 0)) }}</span>
            </template>
            <template #cell(nb_lines_used)="data">
                <span class="text-right d-block">{{ data.item.nb_lines_used }}</span>
            </template>
            <template #cell(amount_used)="data">
                <span class="text-right d-block number-font">{{ formatNumber((data.item.total_credit_used || 0) - (data.item.total_debit_used || 0)) }}</span>
            </template>
        </b-table>

        <div v-else-if="!loading && form.year && form.accounting_firm_company_id" class="alert alert-info mt-3">
            Aucune donnée trouvée pour cette période.
        </div>
    </div>
</template>

<style scoped>

</style>
